// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-89f13b74] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/*!
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
.header-menu[data-v-89f13b74] {
  position: relative;
  width: var(--header-height);
  height: var(--header-height);
}
.header-menu .header-menu__trigger[data-v-89f13b74] {
  --button-size: var(--header-height) !important;
  height: var(--header-height);
  opacity: 0.85;
  filter: none !important;
  color: var(--color-background-plain-text, var(--color-primary-text)) !important;
}
.header-menu .header-menu__trigger[data-v-89f13b74]:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.header-menu .header-menu__trigger[data-v-89f13b74] .button-vue__icon svg,
.header-menu .header-menu__trigger[data-v-89f13b74] .button-vue__icon:not(:has(svg)) {
  mask: var(--header-menu-icon-mask, none);
}
.header-menu--opened .header-menu__trigger[data-v-89f13b74], .header-menu__trigger[data-v-89f13b74]:hover, .header-menu__trigger[data-v-89f13b74]:focus, .header-menu__trigger[data-v-89f13b74]:active {
  opacity: 1;
}
@media only screen and (max-width: 512px) {
.header-menu[data-v-89f13b74] {
    width: var(--default-clickable-area);
}
.header-menu .header-menu__trigger[data-v-89f13b74] {
    --button-size: var(--default-clickable-area) !important;
}
}
.header-menu__wrapper[data-v-89f13b74] {
  position: fixed;
  z-index: 2000;
  top: var(--header-height);
  inset-inline-end: 0;
  box-sizing: border-box;
  margin: 0 8px;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border-radius: var(--border-radius-large);
  background-color: var(--color-main-background);
  filter: drop-shadow(0 1px 5px var(--color-box-shadow));
}
.header-menu__carret[data-v-89f13b74] {
  position: absolute;
  z-index: 2001;
  bottom: 0;
  inset-inline-start: calc(50% - 10px);
  width: 0;
  height: 0;
  content: " ";
  pointer-events: none;
  border: 10px solid transparent;
  border-bottom-color: var(--color-main-background);
}
.header-menu__content[data-v-89f13b74] {
  overflow: auto;
  width: 350px;
  max-width: calc(100vw - 16px);
  min-height: calc(var(--default-clickable-area) * 1.5);
  max-height: calc(100vh - var(--header-height) * 2);
}
.header-menu__content[data-v-89f13b74] .empty-content {
  margin: 12vh 10px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHeaderMenu-Cjb3kKi1.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,+EAA+E;AACjF;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;;EAEE,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,uDAAuD;AAC3D;AACA;AACA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,4DAA4D;EAC5D,yCAAyC;EACzC,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,qDAAqD;EACrD,kDAAkD;AACpD;AACA;EACE,iBAAiB;AACnB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-89f13b74] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/*!\n * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n.header-menu[data-v-89f13b74] {\n  position: relative;\n  width: var(--header-height);\n  height: var(--header-height);\n}\n.header-menu .header-menu__trigger[data-v-89f13b74] {\n  --button-size: var(--header-height) !important;\n  height: var(--header-height);\n  opacity: 0.85;\n  filter: none !important;\n  color: var(--color-background-plain-text, var(--color-primary-text)) !important;\n}\n.header-menu .header-menu__trigger[data-v-89f13b74]:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n.header-menu .header-menu__trigger[data-v-89f13b74] .button-vue__icon svg,\n.header-menu .header-menu__trigger[data-v-89f13b74] .button-vue__icon:not(:has(svg)) {\n  mask: var(--header-menu-icon-mask, none);\n}\n.header-menu--opened .header-menu__trigger[data-v-89f13b74], .header-menu__trigger[data-v-89f13b74]:hover, .header-menu__trigger[data-v-89f13b74]:focus, .header-menu__trigger[data-v-89f13b74]:active {\n  opacity: 1;\n}\n@media only screen and (max-width: 512px) {\n.header-menu[data-v-89f13b74] {\n    width: var(--default-clickable-area);\n}\n.header-menu .header-menu__trigger[data-v-89f13b74] {\n    --button-size: var(--default-clickable-area) !important;\n}\n}\n.header-menu__wrapper[data-v-89f13b74] {\n  position: fixed;\n  z-index: 2000;\n  top: var(--header-height);\n  inset-inline-end: 0;\n  box-sizing: border-box;\n  margin: 0 8px;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  border-radius: var(--border-radius-large);\n  background-color: var(--color-main-background);\n  filter: drop-shadow(0 1px 5px var(--color-box-shadow));\n}\n.header-menu__carret[data-v-89f13b74] {\n  position: absolute;\n  z-index: 2001;\n  bottom: 0;\n  inset-inline-start: calc(50% - 10px);\n  width: 0;\n  height: 0;\n  content: \" \";\n  pointer-events: none;\n  border: 10px solid transparent;\n  border-bottom-color: var(--color-main-background);\n}\n.header-menu__content[data-v-89f13b74] {\n  overflow: auto;\n  width: 350px;\n  max-width: calc(100vw - 16px);\n  min-height: calc(var(--default-clickable-area) * 1.5);\n  max-height: calc(100vh - var(--header-height) * 2);\n}\n.header-menu__content[data-v-89f13b74] .empty-content {\n  margin: 12vh 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
